import { GetterTree } from "vuex";
import { RootState } from "../types";
import { AnalyticsInt } from "./types";
export const getters: GetterTree<AnalyticsInt, RootState> = {};
